import React, {useState} from 'react'
import styled from 'styled-components'
import {GiHamburgerMenu} from 'react-icons/gi'
import {RxCross2} from 'react-icons/rx'
import { Link } from 'react-scroll'
import { motion } from 'framer-motion'
import { default as logomain } from '../../assets/srelogoyellow.png'


const Navbar = ({ ServiceSection, AboutSection, ContactSection }) => {

  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(true);
  const toggleClose = () => setIsOpen(false);
  console.log(isOpen)

  

  return (
     <Nav>
      <Logo 
        src={logomain} 
        alt="logo" 
        as={motion.img} 
        initial={{ y: -100 ,opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.25 }} />
      <NavItems>
        <Item
        as={motion.li} 
        initial={{ y: -100 ,opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.75, delay: 0.5 }}
        >
          <Link to='ServiceSection' spy={true} smooth={true} offset={0} duration={500} >Services</Link>
        </Item>
        <Item
        as={motion.li} 
        initial={{ y: -100 ,opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.75, delay: 1 }}
        >
          <Link to='AboutSection' spy={true} smooth={true} offset={0} duration={500} >About Us</Link>
        </Item>
        <Item
        as={motion.li} 
        initial={{ y: -100 ,opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.75, delay: 1.5 }}
        >
          <Link to='ContactSection' spy={true} smooth={true} offset={0} duration={500} >Contact Us</Link>
        </Item>
      </NavItems>
      <MenuIcon onClick={toggleOpen} >
        <GiHamburgerMenu  />
      </MenuIcon>
      <Menu isOpen={isOpen} >
       <CloseIcon onClick={toggleClose}>
        <RxCross2 />
       </CloseIcon>
        <MenuItems>
        <Item><Link to='ServiceSection' spy={true} smooth={true} offset={50} duration={500} >Services</Link></Item>
        <Item><Link to='AboutSection' spy={true} smooth={true} offset={50} duration={500} >About Us</Link></Item>
        <Item><Link to='ContactSection' spy={true} smooth={true} offset={50} duration={500} >Contact Us</Link></Item>
        </MenuItems>
      </Menu>
     </Nav>
  )
}

export default Navbar


const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 999;

  margin: 1.75rem 10rem;
  @media (max-width: 1282px){ 
    margin: 1.75rem 7.5rem;
  }

  @media (max-width: 1050px){ 
    margin: 1.75rem 5rem;
  }
`

const Logo = styled.img`
  width: 6rem;
  height: 5.5rem;

`

const NavItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  @media(max-width: 1282px){ 
    gap: 3rem;
  }

  @media(max-width: 1282px){ 
    gap: 2rem;
  }

  @media(max-width: 900px){ 
    display: none;
  }
  
`

const Item = styled.li`
  list-style: none;
  font-family: var(--font-secondary);
  color: var(--black);
  font-size: 1.5rem;
  font-weight: 300;
  cursor: pointer;

  box-shadow: inset 0 0 0 0 #F2CB05;
  color: #000;
  margin: 0 -.25rem;
  padding: 0 .25rem;
  transition: color .3s ease-in-out, box-shadow .3s ease-in-out;

  &:hover {
    box-shadow: inset 200px 0 0 0 #F2CB05;
  }

  @media(max-width: 1282px){ 
    font-size: 1.35rem;
  }

  @media(max-width: 1050px){ 
    font-size: 1.2rem;
  }
`

const Menu = styled.div`
  display: none;
  background: #F2B705;
  width: 50vw;
  height: 100vh;
  position: fixed;
  top: 0%;
  right: ${({isOpen}) => isOpen ? '0%' : '-100%'};
  transition: right 1s ease-in-out;
  z-index: 1;
  overflow-y: hidden;
  overflow-x: hidden;
  @media (max-width: 900px) { 
    display: ${({isOpen}) => isOpen ? 'block' : 'none'};
    display: grid;
    place-items: center;
  }
`

const MenuIcon = styled.div`
  display: none;
  position: relative;
  font-size: 30px;
  @media (max-width: 900px){ 
    display: block;
  }
`

const CloseIcon = styled.div`
  position: fixed;
  top: 10%;
  right: 10%;
  color: #fff;
  font-size: 32px;
  opacity: ${({isOpen}) => isOpen === false ? '0' : '1'};
`

const MenuItems = styled.div`
  display: none;
  flex-direction: column;
  gap: 1.5rem;
  z-index: 999;
  color: #fff;
  @media (max-width: 900px){ 
    display: flex;
  }
`